import { cn } from '../../lib/styles';

interface DialogOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  state: 'open' | 'closed';
}

export function DialogOverlay({ state, className, ...props }: DialogOverlayProps) {
  return (
    <div
      data-slot="dialog-overlay"
      data-state={state}
      className={cn(
        'fixed inset-0 z-400 bg-black/60',
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        className,
      )}
      {...props}
    />
  );
}
